/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as FaultActions from '../FaultActions'
import * as SecurityActions from '../../security/SecurityActions'
import {injectIntl} from 'react-intl';
import {Table, Radio, Badge, Grid, Button} from '@scuf/common';
import Progress from '../../common/Progress'
import {SYMPTOM_STATES, SYMPTOM_TYPES} from "../common/FaultsConst";
import * as Assets from '../../api/Assets'
import * as Airtime from '../../api/Airtime'
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import {verifyAirtimeException} from "../../utils/Helpers";
import SearchInput from "../../common/SearchInput";

class Observations extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            observations: null,
            apiPoint: userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ? Airtime : Assets,
            searchValue: '',
        }
        this.fetchObservations = this.fetchObservations.bind(this)
        this.setObservationValue = this.setObservationValue.bind(this)
    }

    componentDidMount() {
        this.fetchObservations()
    }

    fetchObservations() {
        const symptomType = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ?
            [SYMPTOM_TYPES.OBSERVATIONS_TYPE, SYMPTOM_TYPES.REPORTED_SYMPTOM]
            :
            [SYMPTOM_TYPES.OBSERVATIONS_TYPE]
        this.props.FaultActions.fetchObservations(this.props.fault.assetId, this.props.fault.faultId,
            userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY), symptomType)
            .then(() => {
                this.setState({
                    observations: this.props.fault.observations.sort((a, b) => {
                        if (a.id === this.props.fault.details.primarySymptom.id) {
                            return -1
                        }
                    })
                })
            })
            .catch(ex => {
                verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
            });
    }

    getObservationsRows(observations) {
        const {intl} = this.props
        return observations.map((o, i) => {
            const primarySymptom = this.props.fault.details.primarySymptom;
            let disable = false
            // If current observation is primary symptom of current fault condition, its modification need to be disabled
            if ((o.id === primarySymptom.id) && (o.description === primarySymptom.name)) {
                disable = true;
            }

            const realState = o.newState || o.state
            let badge = null;
            // If current observation is primary symptom of current fault condition, create notification badge
            if (disable) {
                badge =
                    <Badge color={"grey"}
                           content={intl.formatMessage({id: "fault.troubleshoot.primarySymptom.notification"})}>
                    </Badge>

            }
            return (
                <React.Fragment key={o.id}>
                    <Table.Row className={this.getRowClass("extra-row mobile only", i, 'dark')}>
                        <Table.Cell colSpan="5" disabled={disable}>
                            {o.description}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row className={this.getRowClass("", i, 'dark')}>
                        <Table.Cell className="computer only">
                            <Progress value={o.benefit}
                                      disabled={o.state !== SYMPTOM_STATES.UNKNOWN || o.benefit === 0}/>
                        </Table.Cell>
                        <Table.Cell className="mobile only"/>
                        <Table.Cell textAlign="left" className="computer only" disabled={disable} style={{color: "white"}}>
                            {o.description}
                            {badge}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {this.getObservationRadioButton(o.id, SYMPTOM_STATES.PRESENT, realState, disable)}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {this.getObservationRadioButton(o.id, SYMPTOM_STATES.ABSENT, realState, disable)}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {this.getObservationRadioButton(o.id, SYMPTOM_STATES.UNKNOWN, realState, disable)}
                        </Table.Cell>
                    </Table.Row>
                </React.Fragment>
            )
        })
    }

    getRowClass(className, index, theme) {
        return className + ' ' + (index % 2 === 0 ? 'even' : 'odd') + (theme === 'dark' ? '-dark' : '')
    }

    getObservationRadioButton(id, value, currentValue, disabled) {
        const shouldBeDisabled = disabled ? disabled : this.props.fault.readOnly;
        return (
            <Radio
                name={'observation-'+id}
                checked={currentValue === value}
                onChange={() => this.setObservationValue(id, value)}
                disabled={shouldBeDisabled}
            />
        )
    }

    setObservationValue(id, value) {
        const newOb = this.state.observations.map(o => {
            if (o.id === id) {
                return ({id: o.id, benefit: o.benefit, description: o.description, state: o.state, newState: value})
            }
            return o;
        })
        this.props.FaultActions.submitObservations(this.props.fault.assetId, this.props.fault.faultId, newOb,
            userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)).then(() => {
            this.fetchObservations();
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
    }

    render() {
        const {intl} = this.props

        if (this.state.observations === null) {
            return null
        }
        const rows = this.getObservationsRows(this.state.observations.filter((o) => o.description.toUpperCase().includes(this.state.searchValue)));

        return (
            <div id="observations-step">
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <SearchInput placeholder={intl.formatMessage({id: "filter.search"})} fluid onChange={(value) => this.setState({searchValue: value.toUpperCase()})}/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Table className="unstackable">
                    <Table.Header>
                        <Table.HeaderCell content={intl.formatMessage({id: "fault.troubleshoot.table.header.benefit"})} className="progress-cell computer only"/>
                        <Table.HeaderCell className="mobile only"/>
                        <Table.HeaderCell content={intl.formatMessage({id: "fault.troubleshoot.table.header.observation"})} className="computer only"/>
                        <Table.HeaderCell content={intl.formatMessage({id: "fault.troubleshoot.table.header.present"})} textAlign="center" className="radio-cell"/>
                        <Table.HeaderCell content={intl.formatMessage({id: "fault.troubleshoot.table.header.absent"})} textAlign="center" className="radio-cell"/>
                        <Table.HeaderCell content={intl.formatMessage({id: "fault.troubleshoot.table.header.unknown"})} textAlign="center" className="radio-cell"/>
                    </Table.Header>
                    <Table.Body>
                        {rows}
                    </Table.Body>
                </Table>
                <div className="button-panel">
                    <div className="right">
                        <Button content={intl.formatMessage({id: "fault.troubleshoot.button.next"})} icon="caret-right" iconPosition="right" onClick={this.props.nextButtonClick}/>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        fault: state.fault,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}


export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Observations)))